var $b88000b6bb5594ce$exports = {};
// footer.js
const $b88000b6bb5594ce$var$termsLink = "https://documents.extrata.io/terms-and-conditions";
const $b88000b6bb5594ce$var$privacyLink = "https://documents.extrata.io/privacy-policy";
const $b88000b6bb5594ce$var$refundLink = "https://documents.extrata.io/refund-policy";
const $b88000b6bb5594ce$var$cocLink = "https://documents.extrata.io/code-of-conduct";
function $b88000b6bb5594ce$var$updateFooterLinks() {
    const links = document.querySelectorAll(".footer-link");
    if (links.length === 0) return setTimeout($b88000b6bb5594ce$var$updateFooterLinks, 50);
    links.forEach((link)=>{
        const text = link.textContent.trim().toLowerCase();
        if (text.includes("code of conduct")) link.href = $b88000b6bb5594ce$var$cocLink;
        else if (text.includes("refund")) link.href = $b88000b6bb5594ce$var$refundLink;
        else if (text.includes("privacy")) link.href = $b88000b6bb5594ce$var$privacyLink;
        else if (text.includes("terms")) link.href = $b88000b6bb5594ce$var$termsLink;
    });
}
$b88000b6bb5594ce$var$updateFooterLinks();


//# sourceMappingURL=extrata-register.fc68b3a0.js.map
